import React from 'react';
import { Autocomplete as JoyAutocomplete, FormControl, FormLabel, FormHelperText, AutocompleteOption } from '@mui/joy';
import PropTypes from "prop-types";
import Typography from './Typography';

const defaultGetOptionLabel = option => {
    return option && option.label !== undefined ? option.label : option;
};

const Autocomplete = ({ label, error, warning, disabled, required, onChange, noOptionComponent, noOptionAlwaysVisible, options, getOptionLabel, ...props }) => {

    return (
        <FormControl required={required} error={!!error} color={!error && warning ? 'warning' : undefined} disabled={disabled}>
            <FormLabel>{label}</FormLabel>
            <JoyAutocomplete
                {...props}
                options={options}
                onChange={(evt, val) => { onChange(val) }}
                noOptionsText={noOptionComponent}
                getOptionLabel={getOptionLabel}
                color={!error && warning ? 'warning' : undefined}
                renderOption={(props, option) => {
                    if (option.isNoOption) {
                        return (
                            <AutocompleteOption {...props}>
                                {noOptionComponent}
                            </AutocompleteOption>
                        );
                    }
                    return <AutocompleteOption {...props}>{getOptionLabel(option)}</AutocompleteOption>;
                }}
            />
            <FormHelperText>{error || warning}</FormHelperText>
        </FormControl>
    );
};

Autocomplete.propTypes = {
    label: PropTypes.string,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    noOptionComponent: PropTypes.element,
    noOptionAlwaysVisible: PropTypes.bool,
    options: PropTypes.array,
    getOptionLabel: PropTypes.func,
};

Autocomplete.defaultProps = {
    label: null,
    error: '',
    disabled: false,
    required: false,
    onChange: () => {},
    noOptionComponent: <li>No options</li>,
    noOptionAlwaysVisible: false,
    options: [],
    getOptionLabel: defaultGetOptionLabel
};

export default Autocomplete;